export const styles = {
  distributionZonesWrapper: {
    padding: '20px 40px',
  },
}
